import script from "./ToastCopy.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastCopy.vue?vue&type=script&setup=true&lang=js"

import "./ToastCopy.vue?vue&type=style&index=0&id=7715795d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7715795d"]])

export default __exports__